import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import InterlinkingBlock from '../shared/InterlinkingBlock';
import messages from '../../../messages';

const { similarSearches, locationTitle, popularMakersTitle, popularModelsTitle } = messages;

class InterlinkingCars extends React.PureComponent {
  getSeoField(field) {
    const { links } = this.props;
    const seoLinks = links.selectedSeoLinks;

    return seoLinks && seoLinks.length > 0 ? seoLinks.find(link => link.link === field) : null;
  }

  render() {
    const { links } = this.props;

    if (!links.geo && !links.geoHorizontal && !links.make && !links.model && !links.similar) {
      return null;
    }

    if (
      (!links.geo || !links.geo.length) &&
      (!links.geoHorizontal || !links.geoHorizontal.length) &&
      (!links.make || !links.make.length) &&
      (!links.model || !links.model.length) &&
      (!links.similar || !links.similar.length)
    ) {
      return null;
    }

    const currentMake = this.getSeoField('make');
    const currentModel = this.getSeoField('model');

    return (
      <div id="interlinking">
        {(links.geo || links.geoHorizontal) && (
          <InterlinkingBlock
            title={<FormattedMessage {...locationTitle} />}
            links={links.geo || links.geoHorizontal}
            dataTest="link-v"
          />
        )}
        {links.make && !currentMake && (
          <InterlinkingBlock
            title={<FormattedMessage {...popularMakersTitle} />}
            links={links.make}
            dataTest="link-mk"
          />
        )}
        {links.model && currentMake && !currentModel && (
          <InterlinkingBlock
            title={
              <FormattedMessage {...popularModelsTitle} values={{ '%4$s': currentMake.value }} />
            }
            links={links.model}
            dataTest="link-md"
          />
        )}
        {links.similar && (
          <InterlinkingBlock
            title={<FormattedMessage {...similarSearches} />}
            links={links.similar}
            dataTest="link-sml"
          />
        )}
      </div>
    );
  }
}

InterlinkingCars.propTypes = {
  links: PropTypes.object.isRequired,
};

export default InterlinkingCars;
export { InterlinkingCars as PureInterlinking };



// WEBPACK FOOTER //
// ./app/Serp/components/Interlinking/cars/index.js